<template>
  <div class="header">
    <div class="warp_container h_main">
      <!-- <el-row style="height: 100%;"> -->
      <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" style="height: 100%;box-sizing: border-box;float: none;margin: 0 auto;position: relative;"> -->
      <div class="head_box_logo">
        <router-link to="/">
          <img class="headerLogo" src="../assets/logo.png" />
        </router-link>
        <!--<div class="logo_txt">logo</div>-->
      </div>
      <div class="head_nav">
        <ul class="head_nav_ul">
          <li>
            <div class="head_icon_box" @click="toCity">
              <img class="head_local_icon" src="../assets/local.png" alt />
              <span>{{ city_name }}</span>
            </div>
          </li>
          <li class="head_li_mr">
            <div class="head_icon_box" @click="isShowCate = !isShowCate">
              <img
                class="head_down_arrow_icon"
                src="../assets/down_arrow.png"
                alt
              />
              <span>{{ category_name }}</span>
            </div>
            <div class="category_menu" v-if="isShowCate">
              <ul class="category_menu_ul">
                <li
                  class="category_menu_li"
                  v-for="(item, idx1) in cate_list"
                  :key="idx1"
                >
                  <dt>{{ item.name }}</dt>
                  <div class="category_menu_li_div">
                    <span
                      @click="selCategory(item_child)"
                      v-for="(item_child, idx2) in item.children"
                      :key="idx2"
                      >{{ item_child.name }}</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li style="margin-left:150px">
            <router-link :to="{ path: '/' }">
              <span :class="{ active_nav: head_nav === 1 }">首页</span>
              <div
                class="head_bar"
                :class="{ active_nav: head_nav === 1 }"
              ></div>
            </router-link>
          </li>
          <!-- <li>
                        <router-link :to="{ path: '/courselist' }">
                            <span>课程</span>
                            <div :class="{active_nav : head_nav===2}"></div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/TestpaperList' }">
                            <span>题库</span>
                            <div :class="{active_nav : head_nav===3}"></div>
                        </router-link>
          </li>-->
          <li @click="toMe">
            <span :class="{ active_nav: head_nav === 4 }">我的课程</span>
            <div class="head_bar" :class="{ active_nav: head_nav === 4 }"></div>
          </li>
          <li @click="toQuestion">
            <span :class="{ active_nav: head_nav === 2 }">题库</span>
            <div class="head_bar" :class="{ active_nav: head_nav === 2 }"></div>
          </li>
          <li class="code_li" @mouseenter="isShowScan = true" @mouseleave="isShowScan = false">
            <span>小程序</span>
            <div class="head_bar" :class="{ active_nav: head_nav === 5 }"></div>
            <div class="scan_code_box" v-if="isShowScan"  @mouseleave="isShowScan = false">
              <div class="scan_code_content">
                <img src="../assets/scan_code.jpg" alt="">
              </div>
              <span>微信扫码进入小程序</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="head_login" v-if="userInfo">
        <!-- <span v-if="userInfo">{{userInfo}}丨<span @click="outLogin">退出登录</span></span>
        <span v-else><span @click="showDialogLogin(true)">登录</span>丨<span @click="showDialogSignIn(true)">注册</span></span>-->
        <!-- <img src="../assets/user.png" alt="" @click="flag=!flag"> -->
        <img src="../assets/page_icon/login.png" alt />
        <span class="username">{{ userInfo }}</span>
        <!-- 用户菜单 -->
        <div class="login_nav_box">
          <div class="login_nav_item">
            <router-link :to="{ path: '/me/courses' }">我的课程</router-link>
          </div>
          <div class="login_nav_item">
            <router-link :to="{ path: '/me/order' }">我的订单</router-link>
          </div>
          <div class="login_nav_item">
            <router-link :to="{ path: '/me/setting' }">个人设置</router-link>
          </div>
          <div class="login_nav_item" v-if="userInfo" @click="outLogin">
            退出
          </div>
          <!-- <div class="login_nav_item" v-if="userInfo" @click="login_nav_active($event)" :data-id=4>退出</div> -->
        </div>
        <!-- 用户菜单结束 -->
      </div>
      <span class="username m_w cursor" v-else>
        <span @click="showDialogLogin(true)">登录</span>丨
        <span @click="showDialogSignIn(true)">注册</span>
      </span>
      <!-- 用户菜单 -->
      <!-- <div class="login_nav_box" v-if="flag"> -->
      <!-- <div class="login_nav_box">
                <div class="login_nav_item" @click="login_nav_active($event)" :data-id=1>我的课程</div>
                <div class="login_nav_item" @click="login_nav_active($event)" :data-id=2>我的订单</div>
                <div class="login_nav_item" @click="login_nav_active($event)" :data-id=3>个人设置</div>
                <div class="login_nav_item" v-if="userInfo" @click="login_nav_active($event)" :data-id=4>退出</div>
                <template v-else>
                    <div class="login_nav_item" @click="login_nav_active($event)" :data-id=5>登录</div>
                    <div class="login_nav_item" @click="login_nav_active($event)" :data-id=6>注册</div>
                </template>
      </div>-->
      <!-- 用户菜单结束 -->
      <!-- </el-col> -->
      <!-- </el-row> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../store";
import TMap from "@/js/tcmap.js";

export default {
  data() {
    return {
      // istoken: !!localStorage.getItem('token') ? true : false
      // flag: false,
      cate_list: [],
      isShowCate: false,
      isShowScan:false,
      area_info: null,
      ipNum: 0
    };
  },
  computed: {
    ...mapState([
      "dialogSignIn",
      "dialogLogin",
      "userInfo",
      "head_nav",
      "city_name",
      "category_name"
    ])
  },
  methods: {
    // 跳转地区选择
    toCity() {
      this.$router.push("/citySelect");
    },
    // 获取分类
    getCate() {
      // if (!localStorage.getItem("area_code")) {
      //   this.getGeolocation();
      // } else {
      //   this.getCategory();
      // }
      if (!localStorage.getItem("area_code")||localStorage.getItem("area_code")=='undefined'||localStorage.getItem("area_code")==undefined) {
        if(this.ipNum>2){
          localStorage.setItem("city_name", "广州市");
          this.$store.commit("setCity_info", "广州市");
          localStorage.setItem("area_code", 440100);
          this.getCategory();
        }else{
          this.getGeolocation();
        }
      } else {
        this.getCategory();
      }
    },
    // 获取分类
    getCategory() {
      let query = `area_code=${localStorage.getItem("area_code")}`;
      this.$http
        .get(`/api/v2/course_category/getAreaCategory?${query}`)
        .then(res => {
          if (res.data.code === 1) {
            this.cate_list = res.data.data.category;
            if (!localStorage.getItem("cate_id")) {
              let cate, key, data;
              if(Object.prototype.toString.call(res.data.data.category[0].children)==='[object Object]'||(Object.prototype.toString.call(res.data.data.category[0].children)==='[object Array]'&&res.data.data.category[0].children.length)){
                cate = res.data.data.category[0].children;
                Object.keys(cate).forEach((item, idx) => {
                  if (idx === 0) {
                    key = item;
                  }
                });
                data = cate[key];
              }else{
                for(var i=0;i<res.data.data.category.length;i++){
                  if(Object.prototype.toString.call(res.data.data.category[i].children)==='[object Object]'||(Object.prototype.toString.call(res.data.data.category[i].children)==='[object Array]'&&res.data.data.category[i].children.length)){
                    cate = res.data.data.category[i].children;
                    Object.keys(cate).forEach((item, idx) => {
                      if (idx === 0) {
                        key = item;
                      }
                    });
                    data = cate[key];
                    break;
                  }
                }
              }

              localStorage.setItem("category_name", data.name);
              this.$store.commit("setCategoryName", data.name);
              localStorage.setItem("cate_id", data.id);
            }
          }
        });
    },
    // 获取当前ip所在城市
    getGeolocation() {
      // this.$jsonp(
      //   "https://restapi.amap.com/v3/ip?key=5ec04cc9178fa14bf89d7ca7995c46c6"
      // ).then(res => {
      //   console.log(res);
      //   localStorage.setItem("city_name", res.city);
      //   this.$store.commit("setCity_info", res.city);
      //   localStorage.setItem("area_code", res.adcode);
      //   this.getCategory();
      // });
      this.ipNum=this.ipNum+1
      let that = this;
      TMap.init("QYUBZ-3LSCX-SKW47-ZS3UM-6HLNS-ZEBXZ", "location").then(function (geo){
        geo.getIpLocation(
          function success(position) {
            console.log(position,'获取定位成功999999')
            if(!position||!position.adcode){
              localStorage.setItem("city_name", "广州市");
              that.$store.commit("setCity_info", "广州市");
              localStorage.setItem("area_code", 440100);
            }else{
              localStorage.setItem("city_name", position.city);
              that.$store.commit("setCity_info", position.city);
              localStorage.setItem("area_code", position.adcode);
            }
            that.getCategory();
          },
          function error(result) {
            console.log("获取定位失败", JSON.stringify(result))
            localStorage.setItem("city_name", "广州市");
            that.$store.commit("setCity_info", "广州市");
            localStorage.setItem("area_code", 440100);
          },
          {
            timeout: 1000,
            failTipFlag: true
          }
        )
      })
    },
    // 选择分类
    selCategory(val) {
      localStorage.setItem("category_name", val.name);
      localStorage.setItem("cate_id", val.id);
      this.$store.commit("setCategoryName", val.name);
      this.isShowCate = false;
      location.reload();
      // if (this.$route.path === "/") {
      //   location.reload();
      // } else {
      //   // this.$router.push("/");
      // }
    },
    showDialogLogin(val) {
      // 弹出登录窗口

      store.commit("setDialogLogin", val);
    },
    showDialogSignIn(val) {
      // 弹出注册窗口
      store.commit("setDialogSignIn", val);
    },
    getUserInfo() {
      // 请求用户信息
      this.$http
        .get("/api/v2/User/getUserInfo", {
          headers: {
            token: localStorage.getItem("token")
          }
        })
        .then(res => {
          if (res.data.code === 1) {
            store.commit("setUserInfo", res.data.data.user_nickname);
          } else if (res.data.code === 0) {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    outLogin() {
      // 退出登录
      localStorage.removeItem("token");
      // this.istoken=false;
      store.commit("setUserInfo", null);
      this.$emit("clearPfrom", {});
      this.$router.push("/");
    },
    // toIndex() {

    //     this.$router.push({name: 'index'})
    // },
    // toCourse() {

    //     this.$router.push({path: '/courselist'})
    // },
    // toTestpaper() {

    //     this.$router.push({path: '/TestpaperList'})
    // },
    toMe() {
      this.isShowCate = false;
      if (this.userInfo) {
        this.$router.push({ path: "/me/courses" });
      } else {
        store.commit("setDialogLogin", true);
      }
    },
    toQuestion() {
      this.$router.push({ path: "/testpaperList" });
    }
    // login_nav_active(e) {
    //     // this.flag= false;
    //     if(e.target.dataset.id<=3){
    //         if(this.userInfo){
    //             e.target.dataset.id==1 && this.$router.push({path:'/me/courses'})
    //             e.target.dataset.id==2 && this.$router.push({path:'/me/order'})
    //             e.target.dataset.id==3 && this.$router.push({path:'/me/setting'})
    //         }else{
    //             store.commit('setDialogLogin',true);
    //         }
    //     }
    //     e.target.dataset.id==4 && this.outLogin();
    //     // e.target.dataset.id==5 && this.showDialogLogin(true)
    //     // e.target.dataset.id==6 && this.showDialogSignIn(true)
    // }
  },
  created() {
    localStorage.getItem("token") && this.getUserInfo();
  },
  mounted() {
    this.getCate();
  },
  watch: {
    city_name(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getCate();
      }
    }
  },
  updated() {
    if (localStorage.getItem("token")) {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
a {
  display: inline-block;
}
.header {
  width: 100%;
  height: 80px;
  background: #ffffff;
}
.head_box_logo {
  cursor: pointer;
}
.h_main {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
}
@media screen and (max-width:1200px){
  .h_main{
    width: 850px;
  }
}
/* .warp{
        width: 66.66%;
        box-sizing: border-box;
        margin: 0 auto;
    } */
.head_nav {
  height: 100%;
  position: relative;
}
.head_li_mr {
  position: relative;
  margin: 0 !important;
  margin-right: 200px !important;
}
/* 分类菜单 */
.category_menu {
  width: 1100px;
  padding: 30px 0;
  position: absolute;
  top: 49px;
  left: -100px;
  z-index: 999;
  background: #fff;
  box-shadow: 0px 0px 5px 1px rgba(50, 51, 51, 0.2);
  border-radius: 0px 0px 10px 10px;
  cursor: default;
}
.category_menu ul,
.category_menu ul > li,
.category_menu > ul > li > dd {
  cursor: default;
  padding: 0;
  margin: 0;
}
.category_menu > ul > li > dd {
  cursor: pointer;
}
.category_menu_ul {
  display: flex;
  flex-direction: column;
}
.category_menu_li {
  display: flex;
  font-size: 14px !important;
}
.category_menu_li dt {
  text-align: right;
  min-width: 120px;
  margin-right: 40px;
  margin-bottom: 20px;
}
.category_menu_li span:hover {
  color: #00c590;
}
.category_menu_li_div {
  text-align: left;
  cursor: pointer;
}
.category_menu_li span {
  display: inline-block;
  color: #666;
  margin-right: 18px;
  padding-right: 20px;
  border-right: 1px solid #cccccc;
  margin-bottom: 20px;
}
.category_menu_li span:last-of-type {
  border-width: 0;
}
.category_menu_li:last-of-type {
  margin-bottom: 0;
}
.category_menu_li:hover {
  color: #333 !important;
}
.head_nav_ul {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: 0;
}
.head_nav li {
  position: relative;
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  color: #333333;
  margin: 0 30px;
}
.head_nav li:hover,
.head_nav li:hover a {
  color: #00c590;
}
.head_bar {
  position: absolute;
  bottom: -30px;
  width: 100%;
  height: 5px;
  background: linear-gradient(
    30deg,
    rgba(9, 209, 120, 1),
    rgba(0, 202, 129, 1)
  );
  border-radius: 3px;
  display: none;
  margin-top: -5px;
}
.head_icon_box {
  display: flex;
  align-items: center;
}
.head_local_icon {
  width: 20px;
  height: 25px;
  margin-right: 10px;
}
.head_down_arrow_icon {
  width: 20px;
  height: 11px;
  margin-right: 10px;
}
.active_nav {
  display: block !important;
  color: #00c590;
}
.head_login,
.m_w {
  /* line-height: 80px; */
  display: flex;
  align-items: center;
  min-width: 60px;
  height: 100%;
  font-size: 16px;
  cursor: pointer;
}

.username {
  margin-left: 9px;
  padding-bottom: 5px;
}
.m_w {
  width: 200px;
  /* min-width: 100px; */
  text-align: right;
}
.head_login img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.headerLogo {
  width: 160px;
  /* height: 40px; */
  height: 80px;
  margin-right: -90px;
  vertical-align: middle;
}
.logo_txt {
  float: left;
  margin-left: 70px;
  line-height: 80px;
  font-size: 18px;
}
.verify_btn {
  /* display: inline-block; */
  position: absolute;
  top: 6px;
  right: 5px;
  background: rgba(37, 165, 56, 1);
  border-radius: 15px;
  color: #ffffff;
  padding: 6px;
  font-size: 14px;
}
/* 登录小菜单样式 */
.login_nav_box {
  display: none;
  width: 120px;
  /* height: 160px; */
  background: #ffffff;
  position: absolute;
  top: 80px;
  right: 0px;
  z-index: 20;
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 5px 9px 1px rgba(50, 51, 51, 0.2);
}
.login_nav_item {
  font-size: 16px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.login_nav_item:last-of-type {
  border-radius: 0px 0px 10px 10px;
}
.login_nav_item:hover,
.login_nav_item:hover a {
  background: #00c590;
  color: #ffffff;
}
.head_login:hover .login_nav_box {
  display: block;
}
/* 二维码 */
.scan_code_box {
  position: absolute;
  width: 190px;
  height: 190px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 24px 32px 18px;
  box-shadow: 0px 5px 10px 1px rgba(50, 51, 51, 0.2);
  border-radius: 0px 0px 10px 10px;
  z-index: 999;
  top: 80px;
  left: -62px;
}
.scan_code_content{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  /* background: url('../assets/scan_code_border.png') no-repeat; */
  margin: 0 auto;
  margin-bottom: 16px;
}
.code_li{
  display: flex;
  align-items: center;
  height: 80px;
}
@media screen and (max-width: 1700px){
  .scan_code_box{
    width: 170px;
    height: 170px;
  }
  .scan_code_content{
    width: 110px;
    height: 110px;
  }
}
.scan_code_content img{
  width: 100%;
  height: 100%;
}
.scan_code_box span{
  font-size: 14px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/SubHeader.vue